module.exports = __webpack_public_path__ + "img/task-view.e743cb32.svg";